import { Action } from "@ngrx/store";
import { CreateRoleDto } from "@merchant_api/models/create-role-dto";
import { PermissionDto } from "@merchant_api/models/permission-dto";
import { RoleDetailsDto } from "@merchant_api/models/role-details-dto";


export enum ActionTypes {
    GetRole = "[Role] GetRole",
    GetNewRole = "[Role] GetNewRole",
    GetRoleSucceed = "[Role] GetRoleSucceed",
    GetRoleFail = "[Role] GetRoleFail",
    UpdateRole = "[Role] UpdateRole",
    DeleteRole = "[Role] DeleteRole",
    CreateRole = "[Role] CreateRole"
}

export class GetRoleAction implements Action {

    constructor(
        public id: number
    ) {}

    readonly type = ActionTypes.GetRole;
}

export class GetNewRoleAction implements Action {

    constructor() {}

    readonly type = ActionTypes.GetNewRole;
}

export class GetRoleSucceedAction implements Action {

    constructor(
        public role: RoleDetailsDto,
        public permissionList: PermissionDto[]
    ) {}

    readonly type = ActionTypes.GetRoleSucceed;
}

export class GetRoleFailAction implements Action {

    constructor(
        public error: any
    ) {}

    readonly type = ActionTypes.GetRoleFail;
}

export class UpdateRoleAction implements Action {

    constructor(public role: RoleDetailsDto) {}

    readonly type = ActionTypes.UpdateRole;
}

export class DeleteRoleAction implements Action {

    constructor(public role: RoleDetailsDto) {}

    readonly type = ActionTypes.DeleteRole;
}

export class CreateRoleAction implements Action {

    constructor(public role: CreateRoleDto) {}

    readonly type = ActionTypes.CreateRole;
}
